{
  "name": "yggdrasil",
  "version": "1.7.0",
  "author": "Zeke Sonxx <zeke@zekesonxx.com>",
  "description": "Mojang authentication (Yggdrasil) client",
  "scripts": {
    "test": "mocha -R spec",
    "pretest": "npm run lint",
    "lint": "standard",
    "fix": "standard --fix"
  },
  "main": "./src/index.js",
  "repository": {
    "type": "git",
    "url": "https://github.com/PrismarineJS/node-yggdrasil.git"
  },
  "bugs": {
    "url": "https://github.com/PrismarineJS/node-yggdrasil/issues"
  },
  "keywords": [
    "minecraft",
    "yggdrasil",
    "authentication"
  ],
  "dependencies": {
    "node-fetch": "^2.6.1",
    "uuid": "^8.2.0"
  },
  "license": "MIT",
  "devDependencies": {
    "@types/node": "^17.0.4",
    "@types/node-fetch": "^3.0.3",
    "@types/uuid": "^8.3.0",
    "mocha": "^9.0.0",
    "nock": "^13.0.2",
    "standard": "^16.0.3"
  }
}
